import { TrendingUp, Handshake, Eye, HeartHandshake } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { Testimonials } from "@/components/site/Testimonials";
import { CTA } from "@/components/site/CTA";

const VALUES = [
  [Eye, "Transparency", "Clear statements and honest conversations. You always know what you're paying for."],
  [Handshake, "Partnership", "A dedicated account manager who treats your business like their own."],
  [HeartHandshake, "Service", "Tech support and customer service that respond like real people, because they are."],
  [TrendingUp, "Growth", "Every dollar saved on fees is a dollar you can reinvest in growing."],
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="About us" lines={["We help local", "businesses keep more."]} sub="866Zerofees.com was built on a simple idea: business owners deserve a payments partner that's honest, helpful and on their side." img="/img/owner.jpg" />
      <section id="our-story" className="bg-white px-4 py-24 sm:px-6 lg:px-12 lg:py-32">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <Eyebrow>Our story</Eyebrow>
            <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl">Processing should feel like a partnership.</h2>
          </Reveal>
          <Reveal delay={0.1} className="space-y-6 text-lg leading-relaxed text-emerald-950/80 lg:col-span-7">
            <p>Too many merchants are stuck with confusing statements, surprise fees and support lines that go nowhere. We started 866Zerofees.com to change that.</p>
            <p>We work to eliminate transaction fees, provide free equipment to qualifying merchants, and give every business a dedicated account manager. Behind them is a tech support and customer service team that knows your account.</p>
            <p>No pressure. No hidden costs. Just transparent pricing and people who care about your success.</p>
          </Reveal>
        </div>
        <div id="values" className="mx-auto mt-20 grid max-w-7xl gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map(([I, t, d], i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className={`group h-full rounded-3xl p-8 transition-transform duration-500 hover:-translate-y-2 ${i % 2 ? "bg-[#0B2A6F] text-white" : "bg-[#EAF3FF]"}`} data-testid={`value-card-${i}`}>
                <I className={`h-8 w-8 transition-transform duration-500 group-hover:rotate-12 ${i % 2 ? "text-lime-400" : "text-emerald-600"}`} />
                <p className="mt-10 font-display text-2xl font-extrabold tracking-tight">{t}</p>
                <p className={`mt-2 text-sm ${i % 2 ? "text-emerald-100/85" : "text-emerald-950/75"}`}>{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <Testimonials />
      <CTA />
    </div>
  );
}
